import { Box } from "@mui/material";

function CustomeDivider() {
  return (
    <Box
      sx={{
        borderBottom: "1px solid #c1c1c1",
        width: "100%",
        // If you need specific spacing, you can add it here easily:
        my: 1,
      }}
    />
  );
}

export default CustomeDivider;
